import SectionSkeleton from "../../../../components/ui/SectionSkeleton"
import { Box, Button, Container, Typography } from "@mui/material"
import { Link, Link as NavLink } from "react-router-dom"
import Images from "../../../../assets/js/Images"
import { Fragment, lazy, Suspense } from "react"

const TopBannerB = lazy(() => import("../../../../components/common/TopBannerB"))
const CtaSection = lazy(() => import("../../../../components/ui/CtaSection"))
const Testimonials = lazy(() => import("./Testimonials"))
const AllServices = lazy(() => import("./Services"))
const Workflow = lazy(() => import("./Workflow"))

function Services() {
  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerB
          headline="Support for Every Step of Your Journey."
          subHeadline="Explore coaching, workshops, courses, and personalized wellness plans designed for you."
          bannerImg={Images?.blogs}
        >
          <Box
            sx={{
              gap: 2,
              flexGrow: "1",
              flexBasis: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Button
              sx={{
                flexGrow: "1",
                flexBasis: "0",
              }}
              variant="BannerButton"
              component={Link}
              to={"/help-center"}
            >Find the Right Support
            </Button>
            <Button
              sx={{
                flexGrow: "1",
                flexBasis: "0",
                
              }}
              component="a"
              w-full
              href="#allServices"
              variant="BannerButtonSecondary"
            >View All Services
            </Button>
          </Box>
        </TopBannerB>
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <AllServices />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Workflow />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Testimonials />
      </Suspense>

      <Box
        component="section"
        sx={{ py: { xs: 5, lg: 10 } }}
      >
        <Container maxWidth={false} fixed>
          <Box
            sx={{
              gap: 3,
              mx: "auto",
              maxWidth: 900,
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              color="other.color1"
              variant="displayLarge"

            >Not Sure Where to Start?
            </Typography>
            <Typography
              variant="bodyLead"
              textAlign="center"
              color="other.color2"
            >Take our 2-minute wellness assessment and discover your personalized path to emotional wellness
            </Typography>
            <Button
              size="large"
              variant="CtaButton"
              component={Link}
              to={"/find-specialist"}
              sx={{ mt: "0 !important" }}
            >Start My Free Wellness Assessment
            </Button>
          </Box>
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <CtaSection>
          <Typography
            variant="ctaNormal"
          >Still Have Questions?
          </Typography>
          <Button
            to="/help-center"
            variant="CtaButton"
            LinkComponent={NavLink}
          >Contact Us
          </Button>
        </CtaSection>
      </Suspense>
    </Fragment>
  )
}

export default Services